import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '@services/alert.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/state/app.state';
import { GetAlert } from '@store/actions/user.action';
import { getMarkets } from '@store/selectors/market.selector';
import { take, finalize } from 'rxjs/operators';
import { getAlert } from '@store/selectors/user.selector';
import { Markets } from '@models/markets';
import { MessageService } from '@services/message.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '@models/api-response';

@Component({
    selector: 'app-editar-alertas',
    templateUrl: './editar-alertas.component.html',
    styleUrls: ['./editar-alertas.component.scss'],
    standalone: false
})
export class EditarAlertasComponent {

  editAlertForm: UntypedFormGroup;
  submit = false;
  confirmed = false;
  error = false;
  // True while the request is running: avoids saving the alert more than once
  pending = false;
  numberOnly = '^[0-9]{1,6}([,.][0-9]{1,2})?$';

  isNavBarOpened = false;
  alertId = '';

  variationSelected = '';
  price: number;

  market: Markets;

  constructor(private formBuilder: UntypedFormBuilder, private route: ActivatedRoute,
              private alertService: AlertService,
              private messageService: MessageService,
              private router: Router,
              public store: Store<AppState>,
              public translateService: TranslateService    ) {
    // Created before the alert is read from the store, so its values can be filled in
    this.editAlertForm = this.formBuilder.group({
      variation: ['', Validators.required],
      price: ['', [Validators.required, Validators.pattern(this.numberOnly)]]
    });

    this.alertId = this.route.snapshot.paramMap.get('id');

    if (this.route.snapshot.paramMap.get('type') === 'edit') {
      this.alertId = this.alertId.replace(/\D/g, '');

      this.store.pipe(
        select(getAlert),
        take(1)
      ).subscribe(alerts => {
          const alert = alerts.find(alertItem => alertItem.aid ===  Number(this.alertId));

          if (alert) {
            this.variationSelected = alert.vid;
            this.price = alert.val;

            this.market = alert.market;

            if (this.variationSelected === '>') {
              this.variationSelected = '1';
            } else if (this.variationSelected === '<') {
              this.variationSelected = '2';
            } else {
              this.variationSelected = '3';
            }

            this.editAlertForm.setValue({variation: this.variationSelected, price: this.price});
          }
      });

    } else if (this.route.snapshot.paramMap.get('type') === 'new') {
      this.store.pipe(
        select(getMarkets),
        take(1)
      ).subscribe(markets => {
        this.market = markets.find(marketItem => marketItem.ns === this.alertId);
      });
    }

  }

  get f() { return this.editAlertForm.controls; }

  onSubmit() {
    if (this.editAlertForm.invalid || this.pending) {
        return;
    }

    const args = {
      vid: this.editAlertForm.value.variation,
      val: String(this.editAlertForm.value.price).replace(/,/g, '.'),
      mns: this.market.ns,
      aid: null
    };

    let action: Observable<ApiResponse>;
    if (this.route.snapshot.paramMap.get('type') === 'edit') {
      args.aid = this.alertId;

      action = this.alertService.updateAlert(args);
    } else {
      action = this.alertService.createAlert(args);
    }

    this.pending = true;
    action.pipe(
      finalize(() => this.pending = false)
    ).subscribe((response) => {
      if (response.status === 200 && response.success) {
        this.store.dispatch(new GetAlert());
        this.messageService.show(this.translateService.instant('edp.emarket.editar.alertas.definido.sucesso'));
        this.router.navigate(['/manageAlerts']);
      } else {
        this.messageService.show(this.translateService.instant('edp.emarket.editar.alertas.definido.error'), 'error');
      }
    });

  }

}
